import { render, staticRenderFns } from "./sparepart.vue?vue&type=template&id=f6ef65f6"
import script from "./sparepart.vue?vue&type=script&lang=js"
export * from "./sparepart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports